import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router";
import SignInSide from "./pages/SignInSide";
import {AuthProvider} from "./components/AuthContext";
import {BacktestResultsPage} from "./pages/BacktestResultsPage";
import {EmailVerify} from "./components/EmailVerify";
import {SubscribePage} from "./pages/SubscribePage";
import AccountProfilePage from "./pages/AccountProfilePage";
import {SnackbarProvider} from "./components/SnackbarContext";
import {BacktestHistoryPage} from "./pages/BacktestHistoryPage";
import {FeedbackPage} from "./pages/FeedbackPage";
import {DocsPage} from "./pages/DocsPage";
import {SharedBacktestPage} from "./pages/SharedBacktestPage";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AuthProvider>
        <SnackbarProvider>
          <Routes>
              <Route path="/" element={<App />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/login" element={<SignInSide/>} />
              <Route path="/subscribe" element={<SubscribePage/>} />
              <Route path="/account" element={<AccountProfilePage/>} />
              <Route path="/backtest" element={<BacktestResultsPage/>} />
              <Route path="/backtest/shared/:uniqueId" element={<SharedBacktestPage/>} />
              <Route path="/backtests" element={<BacktestHistoryPage/>} />
              <Route path="/feedback" element={<FeedbackPage/>} />
              <Route path="/auth/github/callback" element={<SignInSide/>} />
              <Route path="/auth/google/callback" element={<SignInSide/>} />
              <Route path="/verify" element={<EmailVerify/>} />
          </Routes>
        </SnackbarProvider>
      </AuthProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
